import service from './baseService';
import { getCompanyId } from '../config';

export const getTripSettingsService = () => {
    return service.get(`/driver-accountSettings`, {
        params: { companyId: getCompanyId() },
    });
};
